import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ReactComponent as PageNotFound } from "assets/svg/404.svg";
import styles from "./styles.module.scss";
import { Helmet } from "react-helmet";

const PageNotFounded = () => {
  return (
    <Container className={styles["page-not-found"]}>
      <Helmet>
        <title>Page not found (404) | Orchid</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Row className="justify-content-center">
        <Col md={5} className={styles["page-not-found__content"]}>
          <h1 className="deep-blue rg-50 questrial">404</h1>
          <h4 className="md-24 gray01 mb-3">Page not found</h4>
          <p className="rg-18">
            Oh no! The page your looking for either doesn't exist or an error
            has occurred.
          </p>
          <Button as={Link as any} to="/">
            Go back home
          </Button>
        </Col>
        <Col md={5} className="text-center">
          <PageNotFound className={styles["page-not-found__img"]} />
        </Col>
      </Row>
    </Container>
  );
};

export default PageNotFounded;
